module.exports = __webpack_public_path__ + "static/media/unnamed.437607e2.jpg";